import { default as server2 } from 'server2';

// api/rest/v1.4.0/lk/pushNotification/subscribe
export const registerFcmSubscription = async (data) => {
	try {
		const {responseJSON} = await server2.my.rest
			.post(
			[
				'lk', 'pushNotification', 'subscribe',
			], {
				body: data,
			});

		return responseJSON.Status;
	} catch (error) {
		error.handled = true;
		throw error;
	}
};
